<template>
  <div class="top">
    <div class="header">
      <router-link to="Home" tag="img" class="logo" :src="img01"></router-link>

      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        background-color="#161616"
        text-color="#fff"
        active-text-color="#fff">
        <el-menu-item index="Home">首页</el-menu-item>
        <!-- <el-menu-item index="Technology_Services">技术与服务</el-menu-item> -->
        <el-menu-item index="Big_Data">保险行业赋能</el-menu-item>
        <el-menu-item index="About_Us">关于我们</el-menu-item>
        <el-menu-item index="Contact_Us">联系我们</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'Header',
    data() {
      return {
        // activeIndex: 'Home',
        img01: require('@/assets/imgs/logo1.png')
      }
    },
    computed: {
      ...mapState({
        activeIndex: state => state.activeIndex
      }),
    },
    methods: {
      handleSelect(key, keyPath) {
        if (this.activeIndex != key) {
          this.$store.commit('changeNavs', key)
          this.$router.push({name: keyPath}).catch(err => err)
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" type="text/scss">
  .top {
    width: 100%;
    height: 60px;
    background-color: #161616;
    position: fixed;
    top: 0;
    z-index: 999;

    .header {
      width: 1200px;
      height: 60px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      .logo {
        width: 121.6px;
        height: 35px;
        display: inline-block;
        float: left;
        margin-left: 23px;
        cursor: pointer;
      }

      .el-menu-demo {
        display: inline-block;
        float: left;
        left: 285px;
        border: none;

        .el-menu-item {
          font-size: 16px;
          margin-right: 56px;
          padding: 0 8px;

          &:hover,&:focus {
            border-bottom: 3px solid #4196FF !important;
            font-size: 22px;
          }
        }
        .el-menu-item.is-active {
          border-bottom: 3px solid #4196FF !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue